/* SheetJS entry point bundled at build time to avoid inline Babel and unsafe-eval */
import * as XLSX from "xlsx";

// Expose a minimal API on window if legacy pages expect it
if (typeof window !== "undefined") {
  window.XLSX = XLSX;
}

export default XLSX;
